import { render, staticRenderFns } from "./CampoScoreConfigAval.vue?vue&type=template&id=517524ce&"
import script from "./CampoScoreConfigAval.vue?vue&type=script&lang=js&"
export * from "./CampoScoreConfigAval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports